var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFaq = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  fillRule: "evenodd",
  d: "M10 0a10.01 10.01 0 0 1 10 10A10 10 0 1 1 10 0m-.4 13.176q-.544 0-.913.384-.367.368-.367.912 0 .527.367.912.384.383.913.384.544 0 .928-.384t.384-.912q0-.544-.384-.912a1.27 1.27 0 0 0-.928-.384m.512-8.944q-2.144 0-3.536 1.648l1.328 1.04Q8.8 5.864 9.935 5.864q.624 0 .977.304.368.288.368.816 0 .432-.256.704-.24.273-.784.64a7 7 0 0 0-.832.656q-.32.288-.56.8-.224.496-.224 1.216v.624h1.904v-.544q0-.608.32-.976.32-.369.976-.8.512-.352.832-.64a2.5 2.5 0 0 0 .544-.736q.225-.464.224-1.104 0-.703-.384-1.296-.384-.592-1.136-.944-.736-.352-1.792-.352",
  clipRule: "evenodd"
})));
export default SvgFaq;